import { hotMatches } from '@/mocks/home';

const matchImages: Record<number, string> = {
  1: 'https://readdy.ai/api/search-image?query=Manchester%20City%20versus%20Liverpool%20football%20match%20intense%20action%20on%20green%20pitch%20at%20night%20stadium%2C%20professional%20soccer%20photography%2C%20dramatic%20lighting%2C%20dark%20moody%20background&width=600&height=400&seq=match-1-prem&orientation=landscape',
  2: 'https://readdy.ai/api/search-image?query=Lakers%20versus%20Warriors%20NBA%20basketball%20game%20intense%20court%20action%20in%20bright%20arena%2C%20professional%20sports%20photography%2C%20dramatic%20lighting%2C%20athletic%20energy&width=600&height=400&seq=match-2-nba&orientation=landscape',
  3: 'https://readdy.ai/api/search-image?query=Real%20Madrid%20versus%20Bayern%20Munich%20champions%20league%20football%20stadium%20atmosphere%20at%20night%2C%20epic%20sports%20photography%2C%20dramatic%20stadium%20lights%2C%20cinematic&width=600&height=400&seq=match-3-ucl&orientation=landscape',
  4: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20intense%20rally%20on%20blue%20hard%20court%20at%20sunset%2C%20dramatic%20golden%20lighting%2C%20sports%20photography%2C%20clean%20background&width=600&height=400&seq=match-4-atp&orientation=landscape',
  5: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20gaming%20arena%20with%20players%20competing%20on%20stage%2C%20colorful%20neon%20lights%2C%20dark%20atmosphere%2C%20professional%20gaming%20setup%2C%20energetic%20crowd&width=600&height=400&seq=match-5-lol&orientation=landscape',
  6: 'https://readdy.ai/api/search-image?query=Chinese%20Super%20League%20football%20match%20in%20modern%20stadium%20at%20night%2C%20intense%20soccer%20action%2C%20dramatic%20lighting%2C%20professional%20sports%20photography&width=600&height=400&seq=match-6-csl&orientation=landscape',
};

export default function HotMatches() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 md:mb-14 gap-4">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门赛事
            </h2>
            <p className="text-foreground-600 text-sm">实时赔率 · 即刻投注</p>
          </div>
          <div className="flex gap-2">
            <button className="whitespace-nowrap px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-all duration-200 cursor-pointer">
              全部赛事
            </button>
            <button className="whitespace-nowrap px-4 py-2 rounded-lg bg-background-100 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-all duration-200 cursor-pointer">
              正在进行
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotMatches.map((match) => (
            <div
              key={match.id}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden relative">
                <img
                  src={matchImages[match.id]}
                  alt={`${match.homeTeam} vs ${match.awayTeam}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  title={`${match.league}: ${match.homeTeam} vs ${match.awayTeam}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                {match.status === 'live' && (
                  <div className="absolute top-3 left-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-red-500/90 text-background-50 text-xs font-medium">
                    <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse"></span>
                    直播中
                  </div>
                )}
                <div className="absolute bottom-3 left-3">
                  <span className="text-xs text-foreground-300 bg-black/40 px-2 py-0.5 rounded">
                    {match.league}
                  </span>
                </div>
              </div>

              <div className="p-4">
                <div className="flex items-center justify-between mb-3">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100">
                      <i className={`${match.homeLogo} text-foreground-600 text-sm`}></i>
                    </div>
                    <span className="text-sm font-medium text-foreground-900">{match.homeTeam}</span>
                  </div>
                  <span className="text-xs font-bold text-foreground-500">VS</span>
                  <div className="flex items-center gap-3">
                    <span className="text-sm font-medium text-foreground-900">{match.awayTeam}</span>
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100">
                      <i className={`${match.awayLogo} text-foreground-600 text-sm`}></i>
                    </div>
                  </div>
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
                  <span className="text-xs text-foreground-500">{match.time}</span>
                  <div className="flex gap-2">
                    {Object.entries(match.odds).map(([key, value]) => (
                      <span
                        key={key}
                        className="whitespace-nowrap px-3 py-1 rounded-md bg-background-100 text-xs font-semibold text-foreground-800 hover:bg-primary-100 hover:text-primary-700 transition-colors duration-200 cursor-pointer"
                      >
                        {value}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}